import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(menuAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  list: {
    my: -1,
    p: 2,
    border: 'none',
    boxShadow: 'md',
    borderRadius: 'md',
    fontSize: 'md',
    maxHeight: '80vh',
    overflowY: 'auto',

    _dark: {
      boxShadow: 'dark-md',
    },
  },

  item: {
    borderRadius: 'sm',
    px: 4,

    // _focus: {
    //   bgColor: 'blue.50'
    // },

    // _active: {
    //   bgColor: 'blue.100'
    // },

    // _checked: {
    //   bgColor: 'blue.100'
    // },

    // _dark: {
    //   _focus: {
    //     bgColor: 'whiteAlpha.50'
    //   },

    //   _active: {
    //     bgColor: 'whiteAlpha.100'
    //   },

    //   _checked: {
    //     bgColor: 'whiteAlpha.100'
    //   }
    // }
  },

  groupTitle: {
    color: 'muted',
    mx: 0,
    px: 4,
    textAlign: 'left',
  },

  divider: {
    my: 2,
    borderColor: 'gray.300',

    _dark: {
      borderColor: 'gray.600',
    },
  },
});

const sizes = {
  xs: {
    item: {
      px: 2,
      py: 1,
    },
  },
  sm: {
    item: {
      px: 4,
      py: 1.5,
    },
  },
  md: {
    item: {
      px: 4,
      py: 2.5,
    },
  },
  lg: {
    item: {
      px: 6,
      py: 3,
    },
  },
};

// export the base styles in the component theme
export const menuTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes,
});
